import { useEffect } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";
import ChatInterface from "./ChatInterface";
import useChatBotStyles from "./ChatPopupStyles";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import TooltippedIcon from "@Components/TooltippedIcon";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ThemeCreator from "@Themes/themeCreator";
import { useState } from "react";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import { useSelector } from "react-redux";

const ChatPopup = ({ open, onClose, orderId }) => {
  // <<==== Notice the props here
  const theme = ThemeCreator();
  const styles = useChatBotStyles();
  const [isGroupActiveTab, setIsGroupActiveTab] = useState(true);
  const [showtwoGroup, setShowtwoGroup] = useState(true);
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user.roles[0] == "CLEARANCE_COORDINATOR") {
      setShowtwoGroup(true);
      setIsGroupActiveTab(true);
    } else if (
      user.roles[0] == "PLANNER" ||
      user.roles[0] == "PLANNING_MANAGER"
    ) {
      setShowtwoGroup(false);
      setIsGroupActiveTab(false);
    } else {
      setShowtwoGroup(false);
      setIsGroupActiveTab(true);
    }
  }, [user]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: styles.paperProps(),
      }}
    >
      <DialogTitle>
        <Box sx={styles.popupHeaderIcons}>
          <CommentRoundedIcon fontSize={"large"} />
          <Typography variant="h5" fontWeight="bold" marginLeft="6px">
            Order Chat
          </Typography>
          <TooltippedIcon
            title="Close Window"
            placement="top"
            icon={
              <CloseRoundedIcon sx={styles.closeButton} onClick={onClose} />
            }
          />
        </Box>
      </DialogTitle>
      {showtwoGroup && (
        <Box sx={styles.tabsContainer}>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{
              ...styles.leftTab,
              ...(isGroupActiveTab ? styles.isActiveTab : styles.isInactiveTab),
            }}
            onClick={() => setIsGroupActiveTab(true)}
          >
            Group Chat <GroupsIcon fontSize="small" />
          </Typography>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{
              ...styles.rightTab,
              ...(isGroupActiveTab ? styles.isInactiveTab : styles.isActiveTab),
            }}
            onClick={() => setIsGroupActiveTab(false)}
          >
            Planner Chat <PersonIcon fontSize="small" />
          </Typography>
        </Box>
      )}

      <DialogContent sx={styles.popupContent}>
        <ChatInterface
          popupWidth={600}
          orderId={orderId}
          isGroupChat={isGroupActiveTab}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ChatPopup;
